import { render } from "./DocsPrivacy.vue?vue&type=template&id=6b14159e"
import script from "./DocsPrivacy.vue?vue&type=script&lang=js"
export * from "./DocsPrivacy.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DocsPrivacy.vue?vue&type=style&index=0&id=6b14159e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__